import axios from 'axios';

// 需要使用代理来解决跨域问题
axios.defaults.baseURL = '';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.timeout = 20000;

// Add a request interceptor
axios.interceptors.request.use((config) => {
    if (config.method === 'post') {
        //config.data = qs.stringify(config.data);
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use((response) => {
    if (response.data.statusCode !== 0) {
        if(response.data.statusCode === 401){
            console.log('服务需要登录')
            return Promise.reject(response.data.error);
        }
        // 需要添加 iview 消息提示
        // Toast(response.data.error.info);
        return Promise.reject(response.data.error);
    }
    return response;
}, (error) => {
    return Promise.reject(error);
});

export default async(url = '', params = {}, method = 'get') => {
    method = method.toLowerCase();
  if (method === 'get') {

    let paramArr = []; //数据拼接字符串

      for (let [key, value] of Object.entries(params)) {
            paramArr.push(key + '=' + value);
        }

      if (paramArr.length > 0) {
            url += '?' + paramArr.join('&');
        }

        return new Promise((resolve, reject) => {
            axios.get(url)
                .then(response => {
                    resolve(response.data);
                }, err => {
                    reject(err);
                })
                .catch((error) => {
                    reject(error)
                })
        });
    } else if (method === 'post') {
        return new Promise((resolve, reject) => {
            axios.post(url, params)
                .then(response => {
                    resolve(response.data.response);
                }, err => {
                    reject(err);
                })
                .catch((error) => {
                    reject(error)
                })
        });
    } else {
        return Promise.reject('传递的参数错误');
    }
}
